import { ApiProperty } from '@nestjs/swagger'

export class TimezoneResponse {
	@ApiProperty({ type: String })
	name: string

	@ApiProperty({ type: String })
	code: string

	@ApiProperty({ type: String })
	shortCode: string

	@ApiProperty({ type: String })
	offset: string
}
